export default {
    fileSearch: {
        page: {
            FileName: 'File Name',
            FileFormat: 'File format',
            UploadedBy: 'Uploader',
            SourceType: 'Source Type',
            FileUpload: 'File Upload',
            Preview: 'Preview',
            Download: 'Download',
        },
        table: {
            Tenant: 'Tenant',
            Grouping: 'Group',
            UploadDirectory: 'Upload Directory',
            AssociationTable: 'Associated Table',
            FileType: 'File Type',
            FileName: 'File Name',
            UploadedBy: 'Uploader',
            CreationTime: 'Creation Time',
            UpdateTime: 'Date Uploaded',
            FileSize: 'File Size',
            BatchNo: 'Batch Number',
            SourceType: 'Source Type',
        },
        dialog: {
            Configuration: 'Configuration',
            FileClassification: 'File Classification',
            code: 'Storage Configuration Code',
            file: 'File'
        },
        common: {
            Grouping: 'Group',
            UploadDirectory: 'Upload Directory',
        }
    },
};
